import { toastr as baseToastr } from 'react-redux-toastr';

/*
 * Toast wrapper — Module UI Guide Law 16: severity decides the duration, not
 * the caller. info/success 4s, warning 7s, error never (0 = stays until the
 * user dismisses it). Drop-in for `react-redux-toastr`'s `toastr`: re-point an
 * import from 'react-redux-toastr' to 'src/utils/toast' and nothing else
 * changes at the call site.
 */
const DURATIONS = {
	success: 4000,
	info: 4000,
	warning: 7000,
	error: 0, // never auto-dismiss — an error needs an explicit dismiss
};

const withDuration = (type) => (title, message, options = {}) =>
	baseToastr[type](title, message, { ...options, timeOut: DURATIONS[type] });

export const toastr = {
	...baseToastr,
	success: withDuration('success'),
	info: withDuration('info'),
	warning: withDuration('warning'),
	error: withDuration('error'),
};

export default toastr;
